import angular from "angular";

angular
	.module('app')
	.component('notificationCourseStarted', {
		template: require('./notification-course-started.html'),
        controller: ['$http',controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http) {

	let $ctrl = this;

	$ctrl.$onInit = function () {
        $ctrl.notify = $ctrl.resolve.notification;
    };
}
